/*
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Mirror of the Prisma enums in backend/prisma/schema/.
 * Regenerate with:  npm run types:generate
 * CI fails if this file is stale (npm run types:check).
 *
 * 🔴 One enum, one vocabulary (docs/engineering/database.md §3). The
 * predecessor hand-maintained a parallel client-side set and the two
 * drifted; this file exists so that cannot happen again. If you find
 * yourself editing it, edit the schema instead.
 */

export const AuditAction = {
  ROSTER_IMPORT: 'ROSTER_IMPORT',
  SUPER_ADMIN_ACCESS: 'SUPER_ADMIN_ACCESS',
  SCHOOL_STATUS_CHANGE: 'SCHOOL_STATUS_CHANGE',
  ROLE_CHANGE: 'ROLE_CHANGE',
  CONTENT_PUBLISH: 'CONTENT_PUBLISH',
  DATA_EXPORT: 'DATA_EXPORT',
  DATA_ERASURE: 'DATA_ERASURE',
  CONSENT_GRANTED: 'CONSENT_GRANTED',
  CONSENT_REVOKED: 'CONSENT_REVOKED',
  ACADEMIC_ROLLOVER: 'ACADEMIC_ROLLOVER',
  IMPERSONATION_START: 'IMPERSONATION_START',
  IMPERSONATION_END: 'IMPERSONATION_END',
  STAFF_INVITE: 'STAFF_INVITE',
  STAFF_INVITE_CLAIMED: 'STAFF_INVITE_CLAIMED',
  SCHOOL_ACCESS_BLOCKED: 'SCHOOL_ACCESS_BLOCKED',
  CONTENT_STATE_CHANGE: 'CONTENT_STATE_CHANGE',
  FEATURE_FLAG_CHANGE: 'FEATURE_FLAG_CHANGE',
  MAINTENANCE_MODE_CHANGE: 'MAINTENANCE_MODE_CHANGE',
  STAFF_ROLE_CHANGE: 'STAFF_ROLE_CHANGE',
  RETENTION_POLICY_CHANGE: 'RETENTION_POLICY_CHANGE',
  MFA_ENABLED: 'MFA_ENABLED',
  MFA_DISABLED: 'MFA_DISABLED',
  MFA_RECOVERY_USED: 'MFA_RECOVERY_USED',
  PLAY_AS_CHILD: 'PLAY_AS_CHILD',
  BILLING_CHANGE: 'BILLING_CHANGE',
  SUPPORT_UPDATE: 'SUPPORT_UPDATE',
  SCHOOL_UPDATE: 'SCHOOL_UPDATE',
  SCHOOL_APPROVED: 'SCHOOL_APPROVED',
  INVOICE_ISSUED: 'INVOICE_ISSUED',
  INVOICE_SENT: 'INVOICE_SENT',
  INVOICE_REMINDER: 'INVOICE_REMINDER',
  INVOICE_VOIDED: 'INVOICE_VOIDED',
  PAYMENT_LINK_CREATED: 'PAYMENT_LINK_CREATED',
  PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',
  PAYMENT_RECORDED: 'PAYMENT_RECORDED',
  PAYMENT_MATCHED: 'PAYMENT_MATCHED',
  CREDIT_NOTE_ISSUED: 'CREDIT_NOTE_ISSUED',
  REFUND_ISSUED: 'REFUND_ISSUED',
  TDS_UPDATE: 'TDS_UPDATE',
  SEAT_REQUESTED: 'SEAT_REQUESTED',
  SEAT_REQUEST_CANCELLED: 'SEAT_REQUEST_CANCELLED',
  SEAT_REQUEST_DECIDED: 'SEAT_REQUEST_DECIDED',
  NOTE_ADDED: 'NOTE_ADDED',
  NOTE_UPDATED: 'NOTE_UPDATED',
  NOTE_DELETED: 'NOTE_DELETED',
  LEAD_CREATED: 'LEAD_CREATED',
  LEAD_STATUS_CHANGE: 'LEAD_STATUS_CHANGE',
  LEAD_ASSIGNED: 'LEAD_ASSIGNED',
  QUOTE_CHANGE: 'QUOTE_CHANGE',
  GROUP_CHANGE: 'GROUP_CHANGE',
  PRICING_CHANGE: 'PRICING_CHANGE',
  PRICE_OVERRIDE: 'PRICE_OVERRIDE',
  SETTINGS_CHANGE: 'SETTINGS_CHANGE',
  WEBSITE_CONTENT_CHANGE: 'WEBSITE_CONTENT_CHANGE',
  GAME_RELEASE_CHANGE: 'GAME_RELEASE_CHANGE',
  ATTENDANCE_SAVED: 'ATTENDANCE_SAVED',
  SCHEDULE_CHANGE: 'SCHEDULE_CHANGE',
  SCHOOL_SETTINGS_CHANGE: 'SCHOOL_SETTINGS_CHANGE',
  TERM_CHANGE: 'TERM_CHANGE',
  PREFERENCE_CHANGE: 'PREFERENCE_CHANGE',
  PASSWORD_RESET_REQUESTED: 'PASSWORD_RESET_REQUESTED',
  PASSWORD_RESET: 'PASSWORD_RESET',
  LOGIN_RESET: 'LOGIN_RESET',
  ASSIGNMENT_CHANGE: 'ASSIGNMENT_CHANGE',
  PROGRESS_CARD_SIGNED: 'PROGRESS_CARD_SIGNED',
} as const

export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction]

export const BillingPeriod = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  YEARLY: 'YEARLY',
} as const

export type BillingPeriod = (typeof BillingPeriod)[keyof typeof BillingPeriod]

export const SubscriptionStatus = {
  TRIAL: 'TRIAL',
  ACTIVE: 'ACTIVE',
  PAST_DUE: 'PAST_DUE',
  GRACE: 'GRACE',
  CANCELLED: 'CANCELLED',
} as const

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus]

export const SubscriptionAction = {
  STARTED: 'STARTED',
  PLAN_CHANGED: 'PLAN_CHANGED',
  PAYMENT_RECORDED: 'PAYMENT_RECORDED',
  MARKED_PAST_DUE: 'MARKED_PAST_DUE',
  ENTERED_GRACE: 'ENTERED_GRACE',
  RESUMED: 'RESUMED',
  CANCELLED: 'CANCELLED',
  TRIAL_GRANTED: 'TRIAL_GRANTED',
  TRIAL_CHANGED: 'TRIAL_CHANGED',
  COUPON_APPLIED: 'COUPON_APPLIED',
  COUPON_REMOVED: 'COUPON_REMOVED',
} as const

export type SubscriptionAction = (typeof SubscriptionAction)[keyof typeof SubscriptionAction]

export const CouponKind = {
  PERCENT: 'PERCENT',
  AMOUNT: 'AMOUNT',
  PER_STUDENT: 'PER_STUDENT',
} as const

export type CouponKind = (typeof CouponKind)[keyof typeof CouponKind]

export const PaymentStatus = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
} as const

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus]

export const PaymentSource = {
  RAZORPAY: 'RAZORPAY',
  MANUAL: 'MANUAL',
} as const

export type PaymentSource = (typeof PaymentSource)[keyof typeof PaymentSource]

export const InvoiceKind = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  SEATS: 'SEATS',
  OTHER: 'OTHER',
} as const

export type InvoiceKind = (typeof InvoiceKind)[keyof typeof InvoiceKind]

export const InvoiceStatus = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  PAID: 'PAID',
  VOID: 'VOID',
} as const

export type InvoiceStatus = (typeof InvoiceStatus)[keyof typeof InvoiceStatus]

export const QuoteStatus = {
  DRAFT: 'DRAFT',
  SENT: 'SENT',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
} as const

export type QuoteStatus = (typeof QuoteStatus)[keyof typeof QuoteStatus]

export const SeatRequestStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  APPLIED: 'APPLIED',
  CANCELLED: 'CANCELLED',
} as const

export type SeatRequestStatus = (typeof SeatRequestStatus)[keyof typeof SeatRequestStatus]

export const SupportCategory = {
  CAMERA: 'CAMERA',
  GAMES: 'GAMES',
  ACCOUNT: 'ACCOUNT',
  BILLING: 'BILLING',
  CLASSROOM: 'CLASSROOM',
  OTHER: 'OTHER',
} as const

export type SupportCategory = (typeof SupportCategory)[keyof typeof SupportCategory]

export const SupportPriority = {
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  URGENT: 'URGENT',
} as const

export type SupportPriority = (typeof SupportPriority)[keyof typeof SupportPriority]

export const SupportStatus = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  WAITING_ON_SCHOOL: 'WAITING_ON_SCHOOL',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
} as const

export type SupportStatus = (typeof SupportStatus)[keyof typeof SupportStatus]

export const SchoolGroupKind = {
  TRUST: 'TRUST',
  CHAIN: 'CHAIN',
  FRANCHISE: 'FRANCHISE',
} as const

export type SchoolGroupKind = (typeof SchoolGroupKind)[keyof typeof SchoolGroupKind]

export const QuoteKind = {
  NEW: 'NEW',
  RENEWAL: 'RENEWAL',
  ADD_ON: 'ADD_ON',
} as const

export type QuoteKind = (typeof QuoteKind)[keyof typeof QuoteKind]

export const GroupBillingMode = {
  PER_SCHOOL: 'PER_SCHOOL',
  CONSOLIDATED: 'CONSOLIDATED',
} as const

export type GroupBillingMode = (typeof GroupBillingMode)[keyof typeof GroupBillingMode]

export const CreditNoteStatus = {
  ISSUED: 'ISSUED',
  APPLIED: 'APPLIED',
  REFUNDED: 'REFUNDED',
  VOID: 'VOID',
} as const

export type CreditNoteStatus = (typeof CreditNoteStatus)[keyof typeof CreditNoteStatus]

export const RefundMethod = {
  RAZORPAY: 'RAZORPAY',
  BANK_TRANSFER: 'BANK_TRANSFER',
} as const

export type RefundMethod = (typeof RefundMethod)[keyof typeof RefundMethod]

export const RefundStatus = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
} as const

export type RefundStatus = (typeof RefundStatus)[keyof typeof RefundStatus]

export const TdsStatus = {
  PENDING: 'PENDING',
  RECEIVED: 'RECEIVED',
  VERIFIED: 'VERIFIED',
  REJECTED: 'REJECTED',
} as const

export type TdsStatus = (typeof TdsStatus)[keyof typeof TdsStatus]

export const BankTxnStatus = {
  UNMATCHED: 'UNMATCHED',
  MATCHED: 'MATCHED',
  IGNORED: 'IGNORED',
} as const

export type BankTxnStatus = (typeof BankTxnStatus)[keyof typeof BankTxnStatus]

export const CameraState = {
  WORKING: 'WORKING',
  BLOCKED: 'BLOCKED',
  NONE: 'NONE',
  UNKNOWN: 'UNKNOWN',
} as const

export type CameraState = (typeof CameraState)[keyof typeof CameraState]

export const InputMode = {
  FULL: 'FULL',
  LITE: 'LITE',
  MOTION: 'MOTION',
  TAP: 'TAP',
} as const

export type InputMode = (typeof InputMode)[keyof typeof InputMode]

export const InvitePurpose = {
  INVITE: 'INVITE',
  PASSWORD_RESET: 'PASSWORD_RESET',
} as const

export type InvitePurpose = (typeof InvitePurpose)[keyof typeof InvitePurpose]

export const JobStatus = {
  RUNNING: 'RUNNING',
  OK: 'OK',
  FAILED: 'FAILED',
  SKIPPED_LOCKED: 'SKIPPED_LOCKED',
  DISABLED: 'DISABLED',
} as const

export type JobStatus = (typeof JobStatus)[keyof typeof JobStatus]

export const DemoRequestStatus = {
  NEW: 'NEW',
  CONTACTED: 'CONTACTED',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED',
} as const

export type DemoRequestStatus = (typeof DemoRequestStatus)[keyof typeof DemoRequestStatus]

export const LeadSource = {
  WEBSITE: 'WEBSITE',
  MANUAL: 'MANUAL',
  REFERRAL: 'REFERRAL',
  EVENT: 'EVENT',
} as const

export type LeadSource = (typeof LeadSource)[keyof typeof LeadSource]

export const MessageSender = {
  TEACHER: 'TEACHER',
  PARENT: 'PARENT',
} as const

export type MessageSender = (typeof MessageSender)[keyof typeof MessageSender]

export const SendStatus = {
  PENDING: 'PENDING',
  SENDING: 'SENDING',
  SENT: 'SENT',
  FAILED: 'FAILED',
  SUPPRESSED: 'SUPPRESSED',
} as const

export type SendStatus = (typeof SendStatus)[keyof typeof SendStatus]

export const DeliveryStatus = {
  SENT: 'SENT',
  DELIVERED: 'DELIVERED',
  READ: 'READ',
  FAILED: 'FAILED',
} as const

export type DeliveryStatus = (typeof DeliveryStatus)[keyof typeof DeliveryStatus]

export const Region = {
  AN: 'AN',
  AP: 'AP',
  AR: 'AR',
  AS: 'AS',
  BR: 'BR',
  CH: 'CH',
  CT: 'CT',
  DH: 'DH',
  DL: 'DL',
  GA: 'GA',
  GJ: 'GJ',
  HR: 'HR',
  HP: 'HP',
  JK: 'JK',
  JH: 'JH',
  KA: 'KA',
  KL: 'KL',
  LA: 'LA',
  LD: 'LD',
  MP: 'MP',
  MH: 'MH',
  MN: 'MN',
  ML: 'ML',
  MZ: 'MZ',
  NL: 'NL',
  OR: 'OR',
  PY: 'PY',
  PB: 'PB',
  RJ: 'RJ',
  SK: 'SK',
  TN: 'TN',
  TG: 'TG',
  TR: 'TR',
  UP: 'UP',
  UT: 'UT',
  WB: 'WB',
} as const

export type Region = (typeof Region)[keyof typeof Region]

export const SchoolStatus = {
  CREATED: 'CREATED',
  ONBOARDING: 'ONBOARDING',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  ARCHIVED: 'ARCHIVED',
} as const

export type SchoolStatus = (typeof SchoolStatus)[keyof typeof SchoolStatus]

export const AgeBand = {
  BAND_3_4: 'BAND_3_4',
  BAND_4_5: 'BAND_4_5',
  BAND_5_6: 'BAND_5_6',
} as const

export type AgeBand = (typeof AgeBand)[keyof typeof AgeBand]

export const ContentState = {
  DRAFT: 'DRAFT',
  BETA: 'BETA',
  PUBLISHED: 'PUBLISHED',
  RETIRED: 'RETIRED',
} as const

export type ContentState = (typeof ContentState)[keyof typeof ContentState]

export const ReleaseAudience = {
  ALL: 'ALL',
  BETA: 'BETA',
  INTERNAL: 'INTERNAL',
} as const

export type ReleaseAudience = (typeof ReleaseAudience)[keyof typeof ReleaseAudience]

export const SiteContentStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
} as const

export type SiteContentStatus = (typeof SiteContentStatus)[keyof typeof SiteContentStatus]

export const RecordingSource = {
  CONSENT: 'CONSENT',
  PARENT: 'PARENT',
  SCHOOL: 'SCHOOL',
  TEACHER: 'TEACHER',
  DEFAULT: 'DEFAULT',
} as const

export type RecordingSource = (typeof RecordingSource)[keyof typeof RecordingSource]

export const EventType = {
  SESSION_START: 'SESSION_START',
  SESSION_END: 'SESSION_END',
  ANSWER_CORRECT: 'ANSWER_CORRECT',
  ANSWER_WRONG: 'ANSWER_WRONG',
  LEVEL_COMPLETE: 'LEVEL_COMPLETE',
  LEVEL_UP: 'LEVEL_UP',
  GESTURE_JUMP: 'GESTURE_JUMP',
  GESTURE_SQUAT: 'GESTURE_SQUAT',
  GESTURE_REACH: 'GESTURE_REACH',
  GESTURE_STEP: 'GESTURE_STEP',
  GESTURE_ACT: 'GESTURE_ACT',
  GESTURE_PLACE: 'GESTURE_PLACE',
  REWARD_EARNED: 'REWARD_EARNED',
  ITEM_RESULT: 'ITEM_RESULT',
} as const

export type EventType = (typeof EventType)[keyof typeof EventType]

export const Skill = {
  NUMERACY: 'NUMERACY',
  LITERACY: 'LITERACY',
  GENERAL_AWARENESS: 'GENERAL_AWARENESS',
  SOCIAL_AWARENESS: 'SOCIAL_AWARENESS',
  MATCHING: 'MATCHING',
  COORDINATION: 'COORDINATION',
  BALANCE: 'BALANCE',
  BODY_AWARENESS: 'BODY_AWARENESS',
} as const

export type Skill = (typeof Skill)[keyof typeof Skill]

export const SessionEndReason = {
  FINISHED: 'FINISHED',
  TIME_LIMIT: 'TIME_LIMIT',
  TEACHER_ENDED: 'TEACHER_ENDED',
  ABANDONED: 'ABANDONED',
} as const

export type SessionEndReason = (typeof SessionEndReason)[keyof typeof SessionEndReason]

export const AnswerMovement = {
  JUMP: 'JUMP',
  REACH: 'REACH',
  STEP: 'STEP',
  LEAN: 'LEAN',
  POINT: 'POINT',
  CARRY: 'CARRY',
  POSE: 'POSE',
  TAP: 'TAP',
  NONE: 'NONE',
} as const

export type AnswerMovement = (typeof AnswerMovement)[keyof typeof AnswerMovement]

export const QuestionOutcome = {
  CORRECT: 'CORRECT',
  WRONG: 'WRONG',
  POSE_MET: 'POSE_MET',
  POSE_MISSED: 'POSE_MISSED',
  NO_ANSWER: 'NO_ANSWER',
} as const

export type QuestionOutcome = (typeof QuestionOutcome)[keyof typeof QuestionOutcome]

export const NotificationKind = {
  WEEKLY_REPORT: 'WEEKLY_REPORT',
  ACHIEVEMENT: 'ACHIEVEMENT',
  REMINDER: 'REMINDER',
  SYSTEM: 'SYSTEM',
  SCHOOL_WEEKLY_REPORT: 'SCHOOL_WEEKLY_REPORT',
  SEATS_LOW: 'SEATS_LOW',
} as const

export type NotificationKind = (typeof NotificationKind)[keyof typeof NotificationKind]

export const NotificationFrequency = {
  IMMEDIATE: 'IMMEDIATE',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  OFF: 'OFF',
} as const

export type NotificationFrequency = (typeof NotificationFrequency)[keyof typeof NotificationFrequency]

export const DeviceClass = {
  LOW: 'LOW',
  MID: 'MID',
  HIGH: 'HIGH',
  UNKNOWN: 'UNKNOWN',
} as const

export type DeviceClass = (typeof DeviceClass)[keyof typeof DeviceClass]

export const RoundResult = {
  COMPLETED: 'COMPLETED',
  ABANDONED_TRACKING: 'ABANDONED_TRACKING',
  ABANDONED_LEFT: 'ABANDONED_LEFT',
} as const

export type RoundResult = (typeof RoundResult)[keyof typeof RoundResult]

export const Role = {
  ADMIN: 'ADMIN',
  TEACHER: 'TEACHER',
  PARENT: 'PARENT',
  SUPER_ADMIN: 'SUPER_ADMIN',
  COORDINATOR: 'COORDINATOR',
  PRINCIPAL: 'PRINCIPAL',
} as const

export type Role = (typeof Role)[keyof typeof Role]

export const OperatorRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  SALES: 'SALES',
  SUPPORT: 'SUPPORT',
  FINANCE: 'FINANCE',
  VIEWER: 'VIEWER',
} as const

export type OperatorRole = (typeof OperatorRole)[keyof typeof OperatorRole]

/**
 * The two Skill families, derived from the schema.
 *
 * Content skills read as a LEVEL ("Numbers · Level 3"); motor skills read as a
 * PERCENTAGE, because they are earned across all five games. Never show a
 * percentage where a level is the honest answer.
 */
export const CONTENT_SKILLS = [Skill.NUMERACY, Skill.LITERACY, Skill.GENERAL_AWARENESS, Skill.SOCIAL_AWARENESS, Skill.MATCHING] as const satisfies readonly Skill[]
export const MOTOR_SKILLS = [Skill.COORDINATION, Skill.BALANCE, Skill.BODY_AWARENESS] as const satisfies readonly Skill[]

export type ContentSkill = (typeof CONTENT_SKILLS)[number]
export type MotorSkill = (typeof MOTOR_SKILLS)[number]

export const isContentSkill = (s: Skill): s is ContentSkill =>
  (CONTENT_SKILLS as readonly Skill[]).includes(s)

export const isMotorSkill = (s: Skill): s is MotorSkill =>
  (MOTOR_SKILLS as readonly Skill[]).includes(s)
